import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Icon } from 'antd';
import _ from 'lodash';
import Select from 'antd/lib/select';

import FilterAmountRange from './FilterAmountRange.component';
import FilterText from './FilterText.component';
import FilterRadio from './FilterRadio.component';
import FilterDateRange from './FilterDateRange.component';
import FilterDatePicker from './FilterDatePicker.component';
import './FilterList.style.less';

const FilterStringForm = Form.create()(FilterText);
const FilterRadioForm = Form.create()(FilterRadio);
const FilterDateRangePickerForm = Form.create()(FilterDateRange);
const FilterDatePickerForm = Form.create()(FilterDatePicker);
const { Option, OptGroup } = Select;

class FilterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
  }
  /**
   * Function for handle when select option dropdown
   */
  _handleChangeSelect = (value, callback = null) => {
    const {
      callHandleApiFilter,
      selectedValue,
      selectedOption,
      handleParentUpdateState,
      handleChildrenUpdateState,
      filterStateHandler,
      filterList,
      viewValue,
    } = this.props;
    let newViewValue;
    let isBooleanType;
    let tempSelectedValue = selectedValue || [];
    let checkCallback;

    if (value !== undefined) {
      Object.keys(filterList).forEach(key => {
        if (value === filterList[key].value) {
          value = filterList[key].paramBackend || value;
          newViewValue = filterList[key].prefixValue;
          checkCallback = filterList[key].withDeselect || false;
          isBooleanType = filterList[key].typeForm === 'boolean';
          filterStateHandler(key, { visible: !isBooleanType });
        }
      });

      // Condition to Prevent trigger When delete selected value by X icon
      if (newViewValue !== undefined) {
        let tempVal;
        if (checkCallback) {
          if (callback) {
            tempSelectedValue = callback(value, tempSelectedValue);
          }
        } else {
          tempVal = {
            param: value,
            valParam: isBooleanType || '',
          };
          const getKey = _.findKey(filterList, { paramBackend: value });

          if (getKey) value = filterList[getKey].value;
          tempSelectedValue.push(tempVal);
        }
        selectedOption.push(value);
        viewValue.push(newViewValue);

        handleChildrenUpdateState({
          openDropdown: false,
          viewValue,
        });

        if (isBooleanType) {
          handleParentUpdateState(
            { selectedOption, selectedValue, pageNow: 1 },
            callHandleApiFilter,
          );
        } else {
          handleParentUpdateState({
            selectedOption,
            selectedValue: tempSelectedValue,
          });
        }
      }
    }
  };

  /**
   * Function for submit after select option dropdown
   */
  _handleSubmitFilter = (index, value, key) => {
    const {
      callHandleApiFilter,
      handleParentUpdateState,
      handleChildrenUpdateState,
      selectedValue,
      filterList,
      viewValue,
      filterStateHandler,
      handleChangePage,
    } = this.props;
    let matchValue;
    const getParamBackend = _.get(filterList[index], `paramBackend`, '');
    const checkType = getParamBackend || filterList[index].value;

    // To handle filter that have formating Value Function, return must array
    if (filterList[index].formatingValue) {
      const getNewFormat = filterList[index].formatingValue(
        checkType,
        value.input,
      );
      for (let i = 0; i < getNewFormat.length; i += 1) {
        matchValue = selectedValue.filter(
          data => data.param === getNewFormat[i].param,
        );
        [matchValue] = matchValue;
        matchValue.valParam = getNewFormat[i].valParam;
      }
    } else {
      matchValue = selectedValue.filter(data => data.param === checkType);
      [matchValue] = matchValue;
      matchValue.valParam = value.input;
    }

    // To handle filter that have customMasking Function
    if (filterList[index].customMasking) {
      value.input = filterList[index].customMasking(value.input);
    }

    const newViewValue = `${viewValue[viewValue.length - 1]} ${value.input}`;

    viewValue.splice(viewValue.findIndex(e => e.includes(key)), 1);
    viewValue.push(newViewValue);

    handleChildrenUpdateState({ viewValue });
    // reset url page to 1 after submit filter
    handleChangePage(1);
    filterStateHandler(index, { visible: false });
    handleParentUpdateState({ selectedValue, pageNow: 1 }, callHandleApiFilter);
  };

  /**
   * Function for handle cancel button
   */
  _handleCancelFilter = (type, key, callback = null) => {
    const {
      selectedValue,
      selectedOption,
      handleChildrenUpdateState,
      handleParentUpdateState,
      viewValue,
      filterStateHandler,
    } = this.props;
    const tempSelectedOption = selectedOption;
    let tempSelectedValue = selectedValue;

    // Start - Special condition for filter that need special callback
    if (callback) {
      tempSelectedValue = callback(key, tempSelectedValue);
    }
    // END - Special condition for filter that need special callback
    else {
      tempSelectedValue.splice(
        tempSelectedValue.findIndex(e => e.param === type),
        1,
      );
    }

    tempSelectedOption.splice(tempSelectedOption.findIndex(e => e === type), 1);
    viewValue.splice(viewValue.findIndex(e => e.includes(key)), 1);

    handleChildrenUpdateState({ viewValue });
    filterStateHandler(type, { visible: false });
    handleParentUpdateState({
      selectedValue: tempSelectedValue,
      selectedOption: tempSelectedOption,
    });
  };

  /**
   * Function for handle when deselect option, using X icon or backspace
   */
  _onDeselect = value => {
    const {
      callHandleApiFilter,
      selectedOption,
      selectedValue,
      handleParentUpdateState,
      handleChildrenUpdateState,
      handleChangePage,
      filterStateHandler,
      filterList,
      viewValue,
      callbackOnDeselect,
    } = this.props;
    const tempSelectedValue = selectedValue;
    const tempSelectedOption = selectedOption;
    const tempViewValue = viewValue;

    const checkValueIS = value.split(' is ');
    const checkValueFROM = value.split(' from ');
    const checkValueBy = value.split(' by ');

    const isHaveConjungtion =
      checkValueIS.length > 1 ||
      checkValueFROM.length > 1 ||
      checkValueBy.length > 1;
    let checkValue;

    if (isHaveConjungtion) {
      if (checkValueFROM.length > 1) {
        [checkValue] = checkValueFROM;
      } else if (checkValueBy.length > 1) {
        [checkValue] = checkValueBy;
      } else {
        [checkValue] = checkValueIS;
      }
    } else {
      checkValue = value
        .split(' ')
        .slice(0, 2)
        .join(' ');
    }

    let getKey;
    const checkCallback = _.findKey(filterList, {
      label: _.startCase(checkValue),
      withDeselect: true,
    });

    // Start - Special condition for submitted date
    if (checkCallback) {
      getKey = callbackOnDeselect(checkValue);
    }
    // End - Special condition for submitted date
    else {
      getKey = _.findKey(filterList, o => o.prefixValue.includes(checkValue));
    }
    if (value) {
      Object.keys(filterList).forEach(key => {
        if (getKey === key) {
          if (filterList[key].onDeselect) {
            if (filterList[key].onDeselect.callback) {
              filterList[key].onDeselect.callback(
                tempSelectedValue,
                tempSelectedOption,
                checkValue,
              );
            }
          } else {
            const fixParam =
              _.get(filterList[key], 'paramBackend') || filterList[key].value;

            tempSelectedValue.splice(
              tempSelectedValue.findIndex(e => e.param.includes(fixParam)),
              1,
            );

            tempSelectedOption.splice(
              tempSelectedOption.findIndex(e => e.includes(fixParam)),
              1,
            );
          }
          filterStateHandler(key, { visible: false });
        }
      });
      tempViewValue.splice(tempViewValue.findIndex(e => e.includes(value)), 1);

      handleChildrenUpdateState({ viewValue: tempViewValue });
      handleParentUpdateState({
        selectedOption: tempSelectedOption,
        selectedValue: tempSelectedValue,
      });

      const tempPageNow = 1;
      handleChangePage(tempPageNow);
      callHandleApiFilter(tempPageNow);
    }
  };

  _onFocus = () => {
    const { filterList, handleChildrenUpdateState } = this.props;
    const checkVisible = _.find(filterList, ['visible', true]);
    // Too prevent open dropdown when there is popup filter value show
    if (!checkVisible) {
      handleChildrenUpdateState({ openDropdown: true });
    }
  };

  _onBlur = () => {
    const { handleChildrenUpdateState } = this.props;
    handleChildrenUpdateState({ openDropdown: false });
  };

  _renderStringForm = () => {
    const { filterList } = this.props;
    const check = _.findKey(filterList, {
      visible: true,
      typeForm: 'string',
    });
    const getPrefix = _.get(filterList, check, '');
    return (
      check && (
        <div className="base-filter-wrapper filter-input-wrapper">
          <FilterStringForm
            onSubmit={this._handleSubmitFilter}
            cancelFunction={this._handleCancelFilter}
            type={check}
            flagPrefix={getPrefix.prefixValue}
          />
        </div>
      )
    );
  };

  _renderAmountRange = () => {
    const { filterList } = this.props;
    const check = _.findKey(filterList, {
      visible: true,
      typeForm: 'amountRange',
    });
    const getOptions = _.get(filterList, check, '');

    return (
      check && (
        <div className="base-filter-wrapper filter-input-wrapper">
          <FilterAmountRange
            range={getOptions.range}
            onSubmit={this._handleSubmitFilter}
            cancelFunction={this._handleCancelFilter}
            type={check}
            flagPrefix={getOptions.prefixValue}
          />
        </div>
      )
    );
  };

  _renderRadioForm = () => {
    const { filterList } = this.props;
    const check = _.findKey(filterList, {
      visible: true,
      typeForm: 'radio',
    });
    let flagType = '';
    let radioOptions = '';
    if (filterList[check] && filterList[check].listOption) {
      flagType = filterList[check].value;
      radioOptions = filterList[check].listOption;
    }
    return (
      check && (
        <div className="base-filter-wrapper filter-radio-wrapper">
          <FilterRadioForm
            options={radioOptions}
            onSubmit={this._handleSubmitFilter}
            cancelFunction={this._handleCancelFilter}
            type={check}
            flagType={flagType}
          />
        </div>
      )
    );
  };

  _renderDateRangePickerForm = () => {
    const { filterList } = this.props;
    const check = _.findKey(filterList, {
      visible: true,
      typeForm: 'dateRangePicker',
    });

    const getLabel = _.get(filterList[check], 'value', 'Submitted Date');

    return (
      check && (
        <div className="base-filter-wrapper filter-datepicker-wrapper">
          <FilterDateRangePickerForm
            onSubmit={this._handleSubmitFilter}
            cancelFunction={this._handleCancelFilter}
            callbackCancel={this.props.callbackCancelFilter}
            type={check}
            showTime={_.get(filterList[check], 'showTime')}
            ranges={_.get(filterList[check], 'ranges')}
            flagType={getLabel}
          />
        </div>
      )
    );
  };

  _renderDatePickerForm = () => {
    const { filterList } = this.props;
    const check = _.findKey(filterList, {
      visible: true,
      typeForm: 'datePicker',
    });

    const flagType = _.get(filterList[check], 'value', 'Submitted Date');
    return (
      check && (
        <div className="base-filter-wrapper filter-datepicker-wrapper">
          <FilterDatePickerForm
            onSubmit={this._handleSubmitFilter}
            cancelFunction={this._handleCancelFilter}
            callbackCancel={this.props.callbackCancelFilter}
            type={check}
            flagType={flagType}
          />
        </div>
      )
    );
  };

  refSelect = r => {
    this.refOption = r;
  };

  render() {
    const { filterList, selectedOption } = this.props;

    const filteredOption = filterList.filter(
      o =>
        !selectedOption.includes(o.value) &&
        o.label.toLowerCase().includes(this.state.searchText),
    );

    return (
      <div className="filter-box-wrapper">
        <Icon type="search" />
        <Select
          mode="multiple"
          placeholder="Search or Add Filters"
          showArrow={false}
          value={this.props.viewValue}
          open={this.props.openDropdown}
          onFocus={this._onFocus}
          onBlur={this._onBlur}
          onDeselect={this._onDeselect}
          onSearch={value => {
            this.setState({ searchText: value.toLowerCase() });
          }}
          filterOption={false}
          ref={this.refSelect}
          onChange={value => {
            this.refOption.blur();
            this.setState({ searchText: '' });
            this._handleChangeSelect(
              value[value.length - 1],
              this.props.callbackChangeSelect,
            );
          }}
        >
          <OptGroup label="Add Filters">
            {filteredOption.map(item => (
              <Option
                className="option-style"
                key={item.label}
                value={item.value}
              >
                {item.label}
              </Option>
            ))}
          </OptGroup>
        </Select>

        {this._renderStringForm()}

        {this._renderRadioForm()}

        {this._renderDateRangePickerForm()}

        {this._renderAmountRange()}

        {this._renderDatePickerForm()}
      </div>
    );
  }
}

FilterList.propTypes = {
  filterList: PropTypes.array,
  viewValue: PropTypes.array,
  openDropdown: PropTypes.bool,
  selectedOption: PropTypes.array,
  selectedValue: PropTypes.array,
  filterStateHandler: PropTypes.func,
  callHandleApiFilter: PropTypes.func,
  handleChildrenUpdateState: PropTypes.func,
  handleParentUpdateState: PropTypes.func,
  handleChangePage: PropTypes.func,
  callbackChangeSelect: PropTypes.func,
  callbackCancelFilter: PropTypes.func,
  callbackOnDeselect: PropTypes.func,
};

export default FilterList;
